export default [
  {
    key: 'checkbox',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    key: 'edit',
    label: '',
    _style: 'width: 40px',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    label: 'アライアンス名',
    key: 'company',
    _style: 'min-width:140px',
  },
  { label: 'Macアドレス', key: 'mac', _style: 'min-width:140px', slot: true },
  { label: 'モデル名', key: 'model', _style: 'min-width:140px;' },
  { label: 'デバイス名', key: 'device_name', _style: 'min-width:140px;' },
  { label: '登録日時', key: 'created_at', _style: 'min-width:140px;' },
  { label: '更新日時', key: 'updated_at', _style: 'min-width:140px;' },
  {
    label: '最終計測日時',
    key: 'last_measure_time',
    _style: 'min-width:140px;',
  },
  { label: '通算計測回数', key: 'mesure_count', _style: 'min-width:140px;' },
  {
    label: '通算計測ユーザ数',
    key: 'mesure_unique_member',
    _style: 'min-width:140px;',
  },
]
